import cn from 'classnames';

import { TaskStatusRef } from '@/tracker/types';

import s from './StatusBadge.module.scss';

type Props = {
  /** Цвет задаёт тип статуса */
  status: TaskStatusRef;
};

const StatusBadge: React.FC<Props> = ({ status }) => (
  <span className={cn(s.badge, s[`badge_${status.type}`])}>{status.name}</span>
);

export { StatusBadge };
